import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initFcm } from './firebase';
import reportWebVitals from './reportWebVitals';
import Store from './Store/Store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
// import "./Styles/font.css";
import './pdfjsConfig';
import 'flowbite';
import './Styles/tailwind.css';
import './Styles/reset.css';
import './Styles/custom.css';

export let persistor = persistStore(Store);

if (process.env.REACT_APP_E2E === 'true') {
  window.__E2E_STORE__ = Store;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={Store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
// TBM·교육일지 게스트(일반 카메라 QR 웹 참석) 화면은 알림을 쓰지 않으므로 알림 권한을 묻지 않음
if (
  !window.location.pathname.startsWith('/tbm/join/') &&
  !window.location.pathname.startsWith('/edu/join/')
) {
  initFcm()
    .then((res) => console.log('FCM ready:', res))
    .catch(console.error);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
